import { PencilIcon, TrashIcon } from '@heroicons/react/20/solid'
import { UserCircleIcon } from '@heroicons/react/24/outline'

export default function OsobaDetailsCard({ osoba, onEdit, onDelete }) {
	const name = osoba?.imie_i_nazwisko || osoba?.imieNazwisko || osoba?.name || 'Osoba'

	return (
		<div className="mb-5 rounded-md border border-gray-200 bg-white px-5 py-4 shadow-sm">
			<div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
				<h1 className="flex items-center gap-2 text-lg font-semibold text-gray-900">
					<UserCircleIcon className="h-6 w-6 text-sky-700" aria-hidden />
					{name}
				</h1>
				<div className="flex flex-wrap items-center gap-2">
					<button
						type="button"
						onClick={onEdit}
						className="inline-flex items-center gap-1 rounded-md border border-blue-100 bg-blue-50 px-3 py-1.5 text-sm font-medium text-blue-700 hover:bg-blue-100">
						<PencilIcon className="h-4 w-4" />
						<span>Edytuj</span>
					</button>
					<button
						type="button"
						onClick={onDelete}
						className="inline-flex items-center gap-1 rounded-md border border-red-100 bg-red-50 px-3 py-1.5 text-sm font-medium text-red-700 hover:bg-red-100">
						<TrashIcon className="h-4 w-4" />
						<span>Usuń</span>
					</button>
				</div>
			</div>
			<dl className="mt-4 grid grid-cols-1 gap-3 border-t border-gray-100 pt-4 text-sm sm:grid-cols-2 lg:grid-cols-4">
				<div>
					<dt className="text-xs font-medium uppercase tracking-wide text-gray-500">Funkcja</dt>
					<dd className="mt-0.5 text-gray-900">{osoba?.funkcja || '-'}</dd>
				</div>
				<div>
					<dt className="text-xs font-medium uppercase tracking-wide text-gray-500">Telefon</dt>
					<dd className="mt-0.5 text-gray-900">{osoba?.telefon || osoba?.tel || '-'}</dd>
				</div>
				<div>
					<dt className="text-xs font-medium uppercase tracking-wide text-gray-500">Email</dt>
					<dd className="mt-0.5 break-all text-gray-900">{osoba?.email || '-'}</dd>
				</div>
			</dl>
		</div>
	)
}
